/* Uniiq mega-menu: hover-intent + keyboard a11y on top of native <details>.
   Progressive enhancement - click/keyboard works without JS; this adds hover. */
(function () {
  function init() {
    var root = document.querySelector('.header__inline-menu');
    if (!root) return;
    var menus = Array.prototype.slice.call(root.querySelectorAll('.mega-menu'));
    if (!menus.length) return;
    var hoverable = window.matchMedia('(min-width: 990px) and (pointer: fine)').matches;
    var openTimer, closeTimer;

    function setState(menu, open) {
      menu.open = open;
      var s = menu.querySelector('summary');
      if (s) s.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function closeAll(except) {
      menus.forEach(function (m) { if (m !== except && m.open) setState(m, false); });
    }

    menus.forEach(function (menu) {
      var summary = menu.querySelector('summary');

      if (hoverable) {
        menu.addEventListener('mouseenter', function () {
          clearTimeout(closeTimer);
          openTimer = setTimeout(function () { closeAll(menu); setState(menu, true); }, 90);
        });
        menu.addEventListener('mouseleave', function () {
          clearTimeout(openTimer);
          closeTimer = setTimeout(function () { setState(menu, false); }, 180);
        });
        menu.addEventListener('focusin', function () {
          clearTimeout(closeTimer); closeAll(menu); setState(menu, true);
        });
        menu.addEventListener('focusout', function (e) {
          if (!menu.contains(e.relatedTarget)) setState(menu, false);
        });
      }

      if (summary) {
        summary.addEventListener('click', function () {
          window.requestAnimationFrame(function () {
            summary.setAttribute('aria-expanded', menu.open ? 'true' : 'false');
          });
        });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        var open = menus.filter(function (m) { return m.open; })[0];
        closeAll(null);
        if (open) { var s = open.querySelector('summary'); if (s) s.focus(); }
      }
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.header__inline-menu .mega-menu')) closeAll(null);
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();